// not-found.js

'use client'

import React from 'react'
import './not-found.scss'
import Head from 'next/head'

export default function NotFound() {

  const handleClick = () => {
    window.location.href = "https://www.altraedge.com";
  }

  return (
    <>
      <Head>
        <title>Altra Edge | Lead Generation & Performance Marketing Experts</title>
        <meta name="description" content="Altra Edge is a lead generation and performance marketing agency helping businesses grow through targeted campaigns and data-driven strategies." />
        <link rel="canonical" href="https://www.altraedge.ca/404" />
      </Head>
      <div className="notFoundParent">
        <p>Looks like you took a wrong turn somewhere...</p>
        <button className="notFoundButton" onClick={() => handleClick()}>Back to Home Page</button>
        {/* <Patchv1/> */}
      </div>
    </>
  )
}
